import { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AuthShell } from './AuthShell';
import { Alert } from '../common/Alert';
import { Button } from '../common/Button';
import { Field } from '../common/Field';
import { Input } from '../common/Input';
import { apiError } from '../../utils/apiError';

export function GuestLoginPage() {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginAsGuest } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const pages = await loginAsGuest(passcode.trim());
      // A passcode bound to a status page goes straight there.
      if (pages.length > 0) {
        window.location.assign(`/status/${pages[0].slug}`);
        return;
      }
      navigate('/');
    } catch (err) {
      setError(apiError(err, 'Invalid or expired passcode'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell subtitle="Enter your guest passcode">
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && <Alert tone="error">{error}</Alert>}

        <Field label="Passcode" required hint="Read-only access to the dashboard, or to the status page the passcode was issued for.">
          {p => (
            <Input
              {...p}
              type="text"
              required
              autoComplete="off"
              autoCapitalize="characters"
              spellCheck={false}
              value={passcode}
              onChange={e => setPasscode(e.target.value)}
              className="font-mono tracking-widest text-center text-lg"
            />
          )}
        </Field>

        <Button type="submit" loading={loading} className="w-full" size="lg">
          {loading ? 'Checking…' : 'Continue'}
        </Button>

        <p className="text-center text-sm text-gray-500 dark:text-gray-400">
          Have an account?{' '}
          <Link to="/login" className="text-brand-600 dark:text-brand-400 hover:underline">Sign in</Link>
        </p>
      </form>
    </AuthShell>
  );
}
